module.exports = __webpack_public_path__ + "img/ornament_curly.8191c653.svg";